import { CreatePost } from '@wellesley/openapi'
import { MutableRefObject } from 'react'

import { Post } from '../../feed/feedsSlice'
import { AuthorIdentityOption } from './ControlsBar/AuthorIdentitySelector'

export type ModalCloseCallback = MutableRefObject<(() => void) | undefined>

export enum PrivacyOptionsVariant {
  Post = 'post',
  Reply = 'reply',
  GroupChannelPublicPost = 'group-channel-public-post',
  GroupChannelPrivatePost = 'group-channel-private-post',
  GroupChannelPublicReply = 'group-channel-public-reply',
  GroupChannelPrivateReply = 'group-channel-private-reply',
}

export type PostPrivacyOptionsVariant =
  | PrivacyOptionsVariant.Post
  | PrivacyOptionsVariant.GroupChannelPublicPost
  | PrivacyOptionsVariant.GroupChannelPrivatePost

export type TPostForm = {
  feed?: Post
  isReply?: boolean
  isModal?: boolean
  isOpenModal?: boolean
  modalTitleText?: string
  userName?: string
  children?: React.ReactNode
  isRepost?: boolean
  fillInit?: boolean
  autoFocus?: boolean
  isPrivacy?: boolean
  className?: string
  pollClassName?: string
  placeholder?: string
  isCompactField?: boolean
  submitButtonText?: string | React.ReactNode
  isDisabledCommentOption?: boolean
  privacyOptionsVariant?: PrivacyOptionsVariant
  userMentionSearchScope?: {
    groupId?: string
  }
  authorIdentityOptions?: AuthorIdentityOption[]
  authorIdentityId?: string | null
  ownerId?: string
  onAuthorIdentityChange?(this: void, value: string | null): void
  onSubmit(this: void, props: CreatePost): Promise<void>
  onCloseModal?(this: void): void
  onFocusChange?(this: void, focused: boolean): void
  onMediaChange?(this: void, count: number): void
}
